module.exports = __webpack_public_path__ + "static/img/solution_img_3.2ecfe3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/nav-solution/solution-n/solution_img_3.png
// module id = kFKn
// module chunks = 22